//@flow
import * as React from 'react';
import { compose } from 'recompose';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';

import DataPollingContainerHOC from './DataPollingContainerHOC';
import withToasts from 'common/components/core/toast/ToastsContainerFactory';
import { ErrorBoundary } from 'common/components/core/errors';
import ClientRoutesContainerWrap from './ClientRoutesContainerWrap';
import EventNotificationHandler from 'container/components/EventNotificationHandler';
import AppErrorHandler from 'container/components/AppErrorHandler';
import AppAuthenticationManager from 'container/components/AppAuthenticationManager';
import ClientUrlRedirectContainer from 'container/containers/ClientUrlRedirectContainer';
import { RouteNotFound } from 'common/components/core/router';
import useSession from 'common/hooks/useSession';

const dataPollingOptions = {
    timeout: 25000
};

const AppRoutes = (): React.Node => {
    const match = useRouteMatch();
    const session = useSession();

    return (
        <Switch>
            <Route
                path={`${match.path}batch`}
                component={ClientUrlRedirectContainer}
            />
            <Route
                path={`${match.path}client/:clientId`}
                component={ClientRoutesContainerWrap}
            />
            <Redirect
                exact
                from={`${match.url}(client)?`}
                to={`/client/${session.dataClientId}/`}
            />
            <RouteNotFound />
        </Switch>
    );
};

const AppContainer = (): React.Node => {
    return (
        <AppAuthenticationManager>
            <ErrorBoundary>
                <AppRoutes />
                <AppErrorHandler />
                <EventNotificationHandler />
            </ErrorBoundary>
        </AppAuthenticationManager>
    );
};

export default (compose(
    withToasts,
    DataPollingContainerHOC(dataPollingOptions)
)(AppContainer): React.AbstractComponent<void>);
